import * as LoadingActionTypes from '../../types/loading';

/**
 * Sets create comments is loading
 * @param {boolean} payload
 */
export const setCreateCommentsLoading = (payload) => ({
    type: LoadingActionTypes.SET_CREATE_COMMENTS_LOADING,
    payload
});

export const setDataViewLoading = (payload) => ({
    type: LoadingActionTypes.SET_DATAVIEW_LOADING,
    payload
});
